<template>
  <div>
    <b-container>
      <!-- RIGHT SECTION -->
      <template v-if="sec === 'right'">
        <b-row>
          <b-col
            lg="6"
            md="12"
            order-lg="1"
            order-md="2"
            order="2"
          >
            <div class="textSec">
              <h2 class="textTitle">
                {{ acf.acf.title }}
              </h2>

              <h3 class="textSub">
                {{ acf.acf.sub_title }}
              </h3>

              <span
                class="text"
                v-html="acf.acf.text"
              ></span>

              <br />

              <b-button
                v-if="id === 4"
                class="moreBtn"
                to="/tour-management"
              >
                Learn More
              </b-button>

              <b-button
                v-if="id === 158 || id === 201"
                class="moreBtn"
                to="contact-us"
              >
                Get in touch today
              </b-button>
            </div>
          </b-col>

          <b-col
            lg="6"
            md="12"
            order-lg="2"
            order-md="1"
            order="1"
          >
            <b-embed
              v-if="id === 158"
              type="iframe"
              aspect="16by9"
              :src="acf.acf.video_url"
              allowfullscreen
            ></b-embed>

            <b-img
              v-else
              :src="acf.acf.image"
            ></b-img>
          </b-col>
        </b-row>
      </template>

      <!-- RIGHT SECTION 1 -->
      <template v-if="sec === 'right_1'">
        <b-row>
          <b-col
            lg="6"
            md="12"
            order-lg="1"
            order-md="2"
            order="2"
          >
            <div class="textSec">
              <h2 class="textTitle">
                {{ acf.acf.title_2 }}
              </h2>

              <h3 class="textSub">
                {{ acf.acf.sub_title_2 }}
              </h3>

              <span
                class="text"
                v-html="acf.acf.text_2"
              ></span>

              <br />
            </div>
          </b-col>

          <b-col
            lg="6"
            md="12"
            order-lg="2"
            order-md="1"
            order="1"
          >
            <b-img
              :src="acf.acf.image_2"
            ></b-img>
          </b-col>
        </b-row>
      </template>

      <!-- LEFT SECTION -->
      <template v-if="sec === 'left'">
        <b-row>
          <b-col
            lg="6"
            md="12"
          >
            <b-img
              :class="{ disk: id === 158 }"
              :src="acf.acf.image_1"
            ></b-img>
          </b-col>

          <b-col
            lg="6"
            md="12"
          >
            <div class="textSec">
              <h2 class="textTitle">
                {{ acf.acf.title_1 }}
              </h2>

              <h3 class="textSub">
                {{ acf.acf.sub_title_1 }}
              </h3>

              <span
                class="text"
                v-html="acf.acf.text_1"
              ></span>

              <br />

              <b-button
                v-if="id === 4"
                class="moreBtn"
                to="/venue-management"
              >
                Learn More
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>

      <!-- LEFT SECTION 1 -->
      <template v-if="sec === 'left_1'">
        <b-row>
          <b-col
            lg="6"
            md="12"
          >
            <b-img
              :src="acf.acf.image_3"
            ></b-img>
          </b-col>

          <b-col
            lg="6"
            md="12"
          >
            <div class="textSec">
              <h2 class="textTitle">
                {{ acf.acf.title_3 }}
              </h2>

              <h3 class="textSub">
                {{ acf.acf.sub_title_3 }}
              </h3>

              <span
                class="text"
                v-html="acf.acf.text_3"
              ></span>

              <br />
            </div>
          </b-col>
        </b-row>
      </template>

    <!-- CENTRE SECTION -->
    <template v-if="sec === 'centre'">
      <b-row class="featureRow">
        <!-- EVENT MANAGEMENT -->
        <b-col
          md="6"
          cols="12"
          class="featureCol"
        >
          <div class="featureCard">
            <div class="featureImage">
              <b-img
                :src="acf.acf.image_2"
                fluid
              ></b-img>
            </div>

            <div class="featureContent">
              <h3 class="featureTitle">
                {{ acf.acf.title_2 }}
              </h3>

              <div
                class="featureText"
                v-html="acf.acf.text_2"
              ></div>

              <h4 class="featureSubtitle">
                {{ acf.acf.title_2_1 }}
              </h4>

              <ul class="featureList">
                <li>
                  {{ acf.acf.event_bullet }}
                </li>

                <li>
                  {{ acf.acf.event_bullet_1 }}
                </li>

                <li>
                  {{ acf.acf.event_bullet_2 }}
                </li>

                <li>
                  {{ acf.acf.event_bullet_3 }}
                </li>
              </ul>
            </div>
          </div>
        </b-col>

        <!-- APPS -->
        <b-col
          md="6"
          cols="12"
          class="featureCol"
        >
          <div class="featureCard">
            <div class="featureImage">
              <b-img
                :src="acf.acf.image_3"
                fluid
              ></b-img>
            </div>

            <div class="featureContent">
              <h3 class="featureTitle">
                {{ acf.acf.title_3 }}
              </h3>

              <div
                class="featureText"
                v-html="acf.acf.text_3"
              ></div>

              <h4 class="featureSubtitle">
                {{ acf.acf.title_3_1 }}
              </h4>

              <ul class="featureList">
                <li>
                  {{ acf.acf.apps_bullet }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_1 }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_2 }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_3 }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_4 }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_5 }}
                </li>

                <li>
                  {{ acf.acf.apps_bullet_6 }}
                </li>
              </ul>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>

    </b-container>
  </div>
</template>

<script>
export default {
  name: "leftImg",

  props: ["acf", "id", "sec"],
};
</script>

<style scoped>
::v-deep .container {
  max-width: 1400px;
  padding: 0;
}

.textTitle {
  color: #212529;
}

.textSub {
  color: #00aeef;
  font-weight: 300;
}

.text > p {
  font-size: 18px;
}

.moreBtn {
  border-color: transparent;
  font-size: 1.5rem;
  background-color: #00aeef;
  color: #f4f4f6;
  font-weight: 300;
  padding: 10px 75px;
  border-radius: 0;
}

.moreBtn:hover {
  background-color: #003460;
}

.grey {
  background-color: #f4f4f6;
}

.bulletCol {
  padding-left: 0;
  padding-right: 0;
}

.rightImg {
  margin-top: 70px;
  margin-left: -50px;
  z-index: 1;
}

.leftImg {
  z-index: 10;
}

.bulletSec {
  padding: 40px 15px;
  width: 80%;
}

ul {
  padding-left: 20px;
}

li::marker {
  color: #00aeef;
}

.disk {
  margin-top: -100px;
  margin-bottom: -100px;
}

@media only screen and (max-width: 1240px) {
  .disk {
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 480px) {
  .rightImg {
    margin-top: 0;
    margin-left: 0;
    background-color: #fff;
  }
}

.featureRow {
  margin-top: 70px;
  margin-bottom: 70px;
  align-items: stretch;
}

.featureCol {
  padding: 15px;
}

.featureCard {
  height: 100%;
  background: #f4f4f6;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.featureCard:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
}

.featureImage {
  width: 100%;
  overflow: hidden;
}

.featureImage img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.featureCard:hover .featureImage img {
  transform: scale(1.03);
}

.featureContent {
  padding: 35px 40px 40px;
}

h3.featureTitle {
  margin: 0 0 15px;
  color: #212529;
  font-size: 30px;
  font-weight: 400;
  line-height: 1.2;
}

.featureText {
  color: #59636d;
  font-size: 17px;
  line-height: 1.7;
  margin-bottom: 25px;
}

.featureText p {
  margin-bottom: 15px;
}

.featureSubtitle {
  position: relative;
  margin: 0 0 20px;
  padding-left: 18px;
  color: #00aeef;
  font-size: 21px;
  font-weight: 400;
  line-height: 1.3;
}

.featureSubtitle::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 4px;
  height: calc(100% - 4px);
  background-color: #00aeef;
}

.featureList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.featureList li {
  position: relative;
  padding: 0 0 10px 25px;
  color: #212529;
  font-size: 16px;
  line-height: 1.5;
}

.featureList li::before {
  content: "•";
  position: absolute;
  left: 3px;
  top: 0;
  color: #00aeef;
  font-size: 22px;
  line-height: 1;
}


/* ================================
   RESPONSIVE
================================ */

@media only screen and (max-width: 991px) {
  .featureRow {
    margin-top: 40px;
  }

  .featureImage img {
    height: 260px;
  }

  .featureContent {
    padding: 30px;
  }
}

@media only screen and (max-width: 767px) {
  .featureRow {
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .featureCol {
    padding: 10px 15px;
  }

  .featureImage img {
    height: 240px;
  }

  .featureContent {
    padding: 25px;
  }

  .featureTitle {
    font-size: 26px;
  }

  .featureText {
    font-size: 16px;
  }
}

@media only screen and (max-width: 480px) {
  .featureImage img {
    height: 200px;
  }

  .featureContent {
    padding: 25px 20px 30px;
  }

  .featureTitle {
    font-size: 24px;
  }
}
